import TeamsListLayout from './TeamsListLayout'

export default TeamsListLayout
